import type { WikiTopic } from "../types.js";
import { prophetSwing } from "./prophet-swing.js";
import { swingIct } from "./swing-ict.js";

/** The two producers that hold for days, in registry order. */
export const swingStrategies: readonly WikiTopic[] = [prophetSwing, swingIct];
